import React from 'react';
import {
  Date,
  Title,
  Subtitle,
  Expiration,
  DateContainer,  
  ExpirationLabel,
  CheckoutComplete,
  ExpirationContainer,
  CompletePurchaseWrapper,
} from './styles'
import { LargeButton } from '../../../components';
import { RightArrow } from '../../../assets/icons/icons';

export default ({ subscriptionData }: { subscriptionData: Object }) => {
  return (
    <CheckoutComplete>
      <Title>Welcome back</Title>
      <Subtitle>{subscriptionData['description']}</Subtitle>
      <ExpirationLabel>Your last subscription</ExpirationLabel>
      <ExpirationContainer>
        <DateContainer>
          <Expiration>Subscription <br /> starting on:</Expiration>
          <Date>{subscriptionData['subscriptionStart']}</Date>
        </DateContainer>
        <RightArrow color="#7D8DA0" />
        <DateContainer>
          <Expiration>Subscription <br /> expire on:</Expiration>
          <Date>{subscriptionData['subscriptionExpire']}</Date>
        </DateContainer>
      </ExpirationContainer>
      <CompletePurchaseWrapper>
        <LargeButton
          fullWidth
          lMargin="0"
          type="submit"
          fSize={'16px'}
          bradius={'8px'}
          rColor="#006BE1"
          colorDisabled={'#B3D7FF'}
          callback={subscriptionData['callback']}
          title={subscriptionData['labelButton']}
        />
      </CompletePurchaseWrapper>
    </CheckoutComplete>
  );
}